module.exports = __webpack_public_path__ + "static/media/icon-edit-blue.cf209a92.svg";